import { render, staticRenderFns } from "./tarifa-lista.vue?vue&type=template&id=fd8639ee&scoped=true"
import script from "./tarifa-lista.vue?vue&type=script&lang=js"
export * from "./tarifa-lista.vue?vue&type=script&lang=js"
import style0 from "./tarifa-lista.vue?vue&type=style&index=0&id=fd8639ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8639ee",
  null
  
)

export default component.exports